"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentContainer = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var ContentContainer = function (props) {
    if (props.mode !== 'CREATE' &&
        (props.status === 'STANDBY' || props.status === 'FETCHING')) {
        return (React.createElement("div", { className: 'content loading-content' },
            React.createElement("div", { className: 'spinner' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.mode !== 'CREATE' && props.status === 'FAILED') {
        return (React.createElement("div", { className: 'content' },
            React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.fetch }))));
    }
    return React.createElement("div", { className: 'content' }, props.children);
};
exports.ContentContainer = ContentContainer;
